import { Filter, Column, FilterCallback, OperatorString, OperatorType, SearchTerm, FilterArguments } from 'angular-slickgrid';
import { SubScriptionMgr } from '../SubscriptionMgr';
import { AnyHandler, AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { ColumnFormatter } from '../formatters/columnformatter';
import { Decorable } from 'src/app/types/decorable';

type KeyEventHandler = (event: any) => void;
export type ColumnFilterInfo = {
	filter: ColumnFilter,
	columns: Array<Decorable>,
	frozenColumn: number
}
export class ColumnFilter implements Filter {
	static columns: Array<Decorable> = [];
	static ready = false;
	static currentInstance: ColumnFilter;
	static completeHandler: AnyHandler;
	columnDef: Column;
	callback: FilterCallback;
	grid: any;
	defaultOperator?: OperatorString | OperatorType;
	operator: OperatorType | OperatorString;
	params?: any | any[];
	searchTerms?: SearchTerm[];
	input: HTMLInputElement;
	keyHandler: KeyEventHandler;
	startAt: number;
	filtering = false;
	filterVal: string | number = '';
	destroyed = false;

	static ClearColumns() {
		ColumnFilter.columns = [];
	}
	static SetColumns(columnDefs: Array<Decorable>): ColumnFilter | undefined {
		ColumnFilter.columns = [];

		for (const column of columnDefs) {
			ColumnFilter.columns.unshift(column);
		}
		ColumnFilter.ready = true;

		return ColumnFilter.currentInstance;
	}
	static GetColumns() {
		return ColumnFilter.columns.slice(0).reverse();
	}
	static SetInstance(filter: ColumnFilter) {
		ColumnFilter.currentInstance = filter;
	}
	static SetCompleteHandler(handler: AnyHandler) {
		ColumnFilter.completeHandler = handler;
	}
	static MoveColumnTo(columnId: string, where: number) {
		ColumnFilter.columns.reverse();
		const currentIndex = ColumnFilter.GetColumnIndex(columnId, 'name');
		const column = ColumnFilter.columns[currentIndex];
		// if (where > currentIndex) {
		ColumnFilter.columns.splice(currentIndex, 1);
		ColumnFilter.columns.splice(where, 0, column);

		//}
		ColumnFilter.columns.reverse();
	}
	static MoveToFront(columnId: string | number, startI: number) {
		ColumnFilter.columns.reverse();
		const i = this.GetColumnIndex(columnId);
		const column = ColumnFilter.columns[i];
		if (i > startI) {
			ColumnFilter.columns.splice(i, 1);
			ColumnFilter.columns.splice(startI, 0, column);
		} else {
			ColumnFilter.columns.splice(startI, 0, column);
			ColumnFilter.columns.splice(i, 1);
		}
		ColumnFilter.columns.reverse();
	}
	static GetColumnIndex(columnId: number | string, from: 'name' | 'id' = 'id') {
		let i = -1;
		for (const column of ColumnFilter.columns) {
			i += 1;
			if (!column) {
				continue;
			}
			if (columnId === column[from]) {
				return i;
			}
		}
	}
	init(args: FilterArguments, isFilterFirstRender?: boolean): void {
		if (!args) {
			throw new Error('[Angular-SlickGrid] A filter must always have an "init()" with valid arguments.');
		}
		ColumnFilter.SetInstance(this);
		this.grid = args.grid;

		this.callback = args.callback;
		this.columnDef = args.columnDef;
		this.searchTerms = (args.hasOwnProperty('searchTerms') ? args.searchTerms : []) || [];
		this.params = !!args.params ? args.params : {};
		this.startAt = !!this.columnDef.params.startIndex ? this.columnDef.params.startIndex : 0
		if (isFilterFirstRender === true) {
			this.createDomElement();
		}
		this.input.value = (this.columnDef.params && this.columnDef.params.filter) ? this.columnDef.params.filter : '';
		this.filterVal = this.input.value;

	}
	SetColumns(columnDefs: Array<Column<any>>) {


	}
	clear(shouldTriggerQuery?: boolean) {
		this.Filter('');
	}
	destroy() {
		this.destroyed = true;
		this.clear();
		this.input.removeEventListener('change', this.keyHandler);
		const fieldId = this.columnDef && this.columnDef.id;
		const $headerElm = this.grid.getHeaderRowColumn(fieldId);
		delete this.input;
		$($headerElm).empty();
		ColumnFilter.ClearColumns();
		ColumnFilter.SetInstance(null);

	};
	getValues(): SearchTerm | SearchTerm[] | undefined {
		return undefined;
	}
	setValues(values: SearchTerm | SearchTerm[] | undefined, operator?: OperatorType | OperatorString): void {

	}

	protected createDomElement(searchTerms?: SearchTerm[]) {
		if (!!this.input) {
			return;
		}
		const fieldId = this.columnDef && this.columnDef.id;
		const $headerElm = this.grid.getHeaderRowColumn(fieldId);
		$($headerElm).empty();

		const input: HTMLInputElement = document.createElement('input');
		input.id = `${fieldId}-filter`;
		input.classList.toggle('column-fitler', true);
		input.classList.toggle('form-control', true);
		this.keyHandler = (function (event: any) {
			if (event.target.id !== this.input.id) {
				return;
			}
			const value = input.value;
			this.Filter(value);
		}).bind(this);
		input.addEventListener('change', this.keyHandler);
		input.attributes['data-columnId'] = fieldId;
		$headerElm.append(input);
		this.input = input;

	}
	Filter(filterVal: string | null) {
		if (filterVal === '') {
			this.filtering = false;
      return;
		}
		const columns = ColumnFilter.columns;
		const frozenColumn = this.grid.getOptions().frozenColumn;;
		const startAt = (frozenColumn > -1) ? frozenColumn + 1 : this.startAt;
		const filteredColumns = [];
		let vals:Array<string> = [];
		if (typeof filterVal === 'string') {
			filterVal = filterVal.trim();


			this.columnDef.params.filter = filterVal;
			vals = filterVal.split(',');
		}
		let i = ColumnFilter.columns.length;
		this.filterVal = filterVal;
		for (const column of columns) {
			if (!column) {
				continue;
			}

			let tags: Array<string>;
			if (column.params && column.params.tags) {
				tags = (column.params.tags instanceof Array) ? column.params.tags : column.params.tags.toLowerCase().split(',');
			} else {
				tags = [];
			}
			i -= 1;
			if (i < startAt) {
				filteredColumns.unshift(column);
				continue;
			}
			if (typeof filterVal !== 'string') {
				continue;
			}
			if (filterVal === '') {
				filteredColumns.unshift(column)
				continue;
			}
			this.filtering = true;
			let matched = false;

			for (const val of vals) {
				switch (val.substr(0, 1)) {
					case '@':
						if (this.MatchVal('' + column.id, val.trim()) === true) {
							matched = true;
						}
						break;
					case '#':
						for (const tag of tags) {
							if (this.MatchVal(tag, val.trim()) === true) {
								matched = true;
							}
						}
						break;
					default:
						let display: string = (column.params.attribute as AttributeInfo).display;
						if (display && (display === '')) {
							display = column.params.attribute.name;
						}
						if (this.MatchVal(display, val) === true) {
							matched = true;
						}
						break;
				}
				if (matched === true) {
					break;
				}
			}
			if (matched === true) {
				filteredColumns.unshift(column);
			}

		}
		if (this.input.value !== filterVal) {
			this.input.value = filterVal;
		}

		this.grid.setColumns(filteredColumns);
		if (!!ColumnFilter.completeHandler) {

			ColumnFilter.completeHandler({ filter: this, columns: filteredColumns, frozenColumn: (frozenColumn) });
		}

	}
	MatchVal(target, value) {
		const type = value.substr(0, 1);
		let starts = (value.substr(-1, 1) === '*');
		let ends = (value.substr(0, 1) === '*');
		let strictEq = (value.indexOf('"') > -1);
		if (!(starts || ends || strictEq)) {
			if (type === '#') {
				strictEq = true;
				starts = false;
				ends = false;
			} else if (type === '@') {
				strictEq = false;
				starts = false;
				ends = false;
			}
		}
		value = value.replace(/[\*\"]/g, '').toLowerCase();
		if (starts) {
			return (target.toLowerCase().indexOf(value) === 0)
		}
		if (ends) {
			return (target.toLowerCase().substr(-value.length) === value);
		}
		if (strictEq) {
			return (target.toLowerCase() === value);
		}
		return target.toLowerCase().indexOf(value) > -1;
	}
	Update() {
		const val = (this.columnDef.params && this.columnDef.params.filter) ? this.columnDef.params.filter : ''
		this.Filter(val);
	}



}
